import React, {Component} from 'react';
import {CLERK_API_URL} from "../../../constants/api_routes";
import {Button, Divider, Form, Grid, Header, Label, Popup, Segment} from "semantic-ui-react";
import ListingContainer from "../../../containers/listing_container";
import moment from 'moment';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import validatePasswordStrength from "../../../utils/password_validation";
import Loader from "../../universal/loader";

class CreateClerkUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            insuranceStartDate: moment().format("DD-MM-YYYY"),
            insuranceEndDate: moment().format("DD-MM-YYYY"),
            pswdLength:false,
            pswdLC:false,
            pswdUC:false,
            pswdSym:false,
            pswdNum:false
        }
    }

    handleSubmit = (event) => {
        this.setState({isSaving:true});
        event.preventDefault();
        const formData = new FormData(event.target);
        formData.append("insurance_start_date", this.state.insuranceStartDate);
        formData.append("insurance_end_date", this.state.insuranceEndDate);
        this.setState({disableSave:true});
        this.props.create(CLERK_API_URL, formData, this.handleCreateResponse);

    };
    handleCreateResponse = (response) => {
        this.setState({isSaving:true});
        if (response.success) {
            this.props.onSuccess();
        }
        this.setState({disableSave:false,error:true,errorMessage:response.s});
    };

    validatePassword = (password) => {
        this.setState({
            pswdLength:validatePasswordStrength.charLength(password),
            pswdLC:validatePasswordStrength.lowercase(password),
            pswdUC:validatePasswordStrength.uppercase(password),
            pswdSym:validatePasswordStrength.special(password),
            pswdNum:validatePasswordStrength.hasNumber(password),
        });
    };

    render() {
        return (
            <div>
                <Header as='h2' textAlign='center'>
                    Create New Clerk User
                </Header>
                {this.state.isSaving && <Loader save={true}/>}
                <Form onSubmit={this.handleSubmit} type="multipart/form-data">
                    <Grid stackable>
                        <Grid.Row>
                            <Grid.Column width={8}>
                                <Segment style={{height:'100%'}}>
                                    <Label color='blue' ribbon>
                                        Profile Details
                                    </Label>
                                    <p></p>
                                    <Form.Input label="Name" icon='user' iconPosition='left' placeholder='Name'
                                                type='text' name="name"
                                                required/>
                                    <Form.Input label="Email Address" icon='at' iconPosition='left'
                                                placeholder='E-mail address'
                                                name="user[email]" required/>
                                    <Popup trigger={
                                        <Form.Input label='Password' fluid icon='lock' iconPosition='left'
                                                    placeholder='Password'
                                                    type='password' name="user[password]" pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[\W])(?=.*\d).{6,}"
                                                    onChange={(e) => {this.validatePassword(e.target.value)}}
                                                    required/>}
                                           content={<Segment>
                                               <p className={this.state.pswdLength?"info-success":"info-negative"}>Password must be 6 chars or more</p>
                                               <p className={this.state.pswdLC?"info-success":"info-negative"}>Must have atleast 1 lowercase</p>
                                               <p className={this.state.pswdUC?"info-success":"info-negative"}>Must have atleast 1 uppercase</p>
                                               <p className={this.state.pswdSym?"info-success":"info-negative"}>Must have atleast 1 special character</p>
                                               <p className={this.state.pswdNum?"info-success":"info-negative"}>Must have atleast 1 Number</p>
                                           </Segment>}
                                           on="focus"
                                           position="right center"
                                           wide
                                           hideOnScroll
                                    />
                                    <Form.Input label="Mobile Number" icon='mobile' iconPosition='left'
                                                placeholder='328659286'
                                                type='text' name="mobile_number"
                                    />
                                </Segment>
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <Segment style={{height:'100%'}}>
                                    <Label color='blue' ribbon>
                                        Emergency Contact Details
                                    </Label>
                                    <p></p>
                                    <Form.Input label='Contact Name' fluid icon='user' iconPosition='left'
                                                placeholder='Contact Name'
                                                type='text' name="emergency_contact_name"
                                    />
                                    <Form.Input label="Contact's Relationship" icon='users' iconPosition='left'
                                                placeholder="Cousin"
                                                name="emergency_contact_relation"/>
                                    <Form.Input label="Email Address" icon='at' iconPosition='left'
                                                placeholder='abc@xyz.info'
                                                name="emergency_contact_email"/>
                                    <Form.Input label="Contact Number" icon='mobile' iconPosition='left'
                                                placeholder='8328659286'
                                                type='text' name="emergency_contact_number"
                                    />
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={8}>
                                <Segment style={{height:'100%'}}>
                                    <Label color='blue' ribbon>
                                        Address Details
                                    </Label>
                                    <Form.Input label="Address Line 1" placeholder='Street'
                                                type='street view' name="line1"
                                                required/>
                                    <Form.Input label="Address Line 2" placeholder='Landmark'
                                                type='street view' name="line2"
                                    />
                                    <Form.Group widths={2}>
                                        <Form.Input label="Locality"
                                                    type='text' name="locality"
                                        />
                                        <Form.Input label="City" placeholder='City'
                                                    type='text' name="city"
                                        />
                                    </Form.Group>
                                    <Form.Group widths={2}>
                                        <Form.Input label="Country" placeholder='Country'
                                                    type='text' name="country"
                                        />
                                        <Form.Input label="Post Code" placeholder='C2PN57'
                                                    type='text' name="postcode" required
                                        />
                                    </Form.Group>
                                </Segment>
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <Segment style={{height:'100%'}}>
                                    <Label color='blue' ribbon>
                                        Documents
                                    </Label>
                                    <Form.Group widths={2}>
                                        <Form.Field>
                                            <Form.Input label="Insurance" type='file' accept="image/*"
                                                        name="insurance"/>
                                        </Form.Field>
                                        <Form.Field><Form.Group widths={2}>
                                            <Form.Field>
                                                <label>Valid From:</label>
                                                <DayPickerInput placeholder="DD-MM-YYYY"
                                                                dayPickerProps={{
                                                                    todayButton: 'Today',
                                                                    firstDayOfWeek : 1,
                                                                }}
                                                                format="DD-MM-YYYY"
                                                                formatDate={formatDate}
                                                                parseDate={parseDate}
                                                                onDayChange={day => this.setState({insuranceStartDate: day})}/>
                                            </Form.Field>
                                            <Form.Field>
                                                <label>Valid Till:</label>
                                                <DayPickerInput placeholder="DD-MM-YYYY"
                                                                dayPickerProps={{
                                                                    disabledDays: {before: this.state.insuranceStartDate},
                                                                    todayButton: 'Today',
                                                                    firstDayOfWeek : 1,
                                                                }}
                                                                format="DD-MM-YYYY"
                                                                formatDate={formatDate}
                                                                parseDate={parseDate}
                                                                onDayChange={day => this.setState({insuranceEndDate: day})}/>
                                            </Form.Field>
                                        </Form.Group>
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Field>
                                    </Form.Field>
                                    <Form.Input label='License Document' type='file' accept="image/*" name="license"/>
                                    <Form.Input label='Signature' type='file' accept="image/*" name="sign"/>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                        <div className="submit-buttons">
                            <Button primary fluid disabled={this.state.disableSave}>Create User</Button>
                        </div>
                    </Grid>
                </Form>
            </div>
        );
    }

}

export default ListingContainer(CreateClerkUser);


// WEBPACK FOOTER //
// ./src/views/user/clerk/create_user.js